
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'AuditLogActionPill',
})
export default class AuditLogActionPill extends Vue {
  @Prop({ required: true })
  protected action!: string;

  // A soft delete: shown as a delete, prefixed with a small "Soft".
  @Prop({ default: false })
  protected soft!: boolean;

  get label(): string {
    const key = 'auditLogs.actions.' + this.action;

    return this.$te(key) ? (this.$t(key) as string) : this.action;
  }
}
